import { isResource } from '@medplum/core'
import { codeableConcept, hasCodeableConcept } from '#src/codeableConcept.ts'
import { LIBRARY_TOPIC } from '#src/codeSystems.ts'
import { ExtendedLibrary } from '#src/models/library.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export class DeskApp extends ExtendedLibrary {
  constructor(data?: ConstructorParameters<typeof ExtendedLibrary>[0]) {
    super({
      ...data,
      topic: [DeskApp.libraryTopic, ...(data?.topic ?? [])],
    })
  }

  static libraryTopic = codeableConcept({
    system: LIBRARY_TOPIC,
    code: 'desk-app',
    display: 'Desk App',
  })

  static isInstance(value: unknown): value is DeskApp {
    return (
      isResource(value) &&
      isOfType(value, 'Library') &&
      hasCodeableConcept(value.topic, DeskApp.libraryTopic)
    )
  }

  static searchQuery(): QueryTypes {
    return {
      topic: this.libraryTopic,
      status: 'active',
      _sort: '-_lastUpdated',
    }
  }
}
